import { store } from "./store";
import authActions from "./auth/actions";
import cookieHelper from "../library/helpers/cookieHelper";

// Validate JWT token before setting auth state
const validateToken = (token) => {
  if (!token) return false;
  
  try {
    // Basic JWT structure check
    const parts = token.split('.');
    if (parts.length !== 3) return false;
    
    // Decode payload (middle part)
    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`)
        .join('')
    );
    const payload = JSON.parse(jsonPayload);
    
    // Check expiration
    const expiredAt = payload.expiredAt || (payload.exp * 1000);
    const now = Date.now();
    
    // Token is valid if not expired (with 5 minute buffer for clock skew)
    return expiredAt > (now + 5 * 60 * 1000);
  } catch (e) {
    console.warn('Token validation failed:', e);
    return false;
  }
};

export default (App) => {
  const token = cookieHelper.getToken() || localStorage.getItem('id_token');
  
  // Only check authorization if token exists AND is valid
  if (token && validateToken(token)) {
    store.dispatch(authActions.checkAuthorization());
  } else {
    // Clear invalid/expired token
    if (token) {
      cookieHelper.clearToken();
      localStorage.removeItem('id_token');
      localStorage.removeItem('last_activity_timestamp');
      localStorage.removeItem('token_expiry_timestamp');
      // Clear Redux state
      store.dispatch({ type: 'LOGOUT' });
    }
  }
  
  return App;
};
